import React from 'react';
import PropTypes from 'prop-types';

// Local drag-to-scroll with click guard; safe to use without affecting other pages
class SmoothDragScroll extends React.Component {
  constructor(props) {
    super(props);
    this.slider = React.createRef();

    this.isDown = false;
    this.dragMoved = false;
    this.startX = 0;
    this.startScrollLeft = 0;
  }

  onPointerDown = (e) => {
    const el = this.slider.current;
    if (!el) return;
    try { el.setPointerCapture(e.pointerId); } catch (_) {}
    this.isDown = true;
    this.dragMoved = false;
    this.startX = e.clientX;
    this.startScrollLeft = el.scrollLeft;
    // Disable snapping during drag to avoid jumpiness
    this.prevSnap = el.style.scrollSnapType || '';
    if (!this.prevSnap && typeof window !== 'undefined') {
      const cs = window.getComputedStyle(el);
      this.prevSnap = cs.scrollSnapType || '';
    }
    el.style.scrollSnapType = 'none';
    el.style.cursor = 'grabbing';
    el.style.userSelect = 'none';
  };

  onPointerMove = (e) => {
    if (!this.isDown) return;
    e.preventDefault();
    const el = this.slider.current;
    if (!el) return;
    const dx = e.clientX - this.startX;
    if (Math.abs(dx) > 4) this.dragMoved = true;
    el.scrollLeft = this.startScrollLeft - dx;
  };

  endDrag = (e) => {
    const el = this.slider.current;
    this.isDown = false;
    if (el) {
      // Restore snap behavior by clearing inline style so CSS applies
      el.style.scrollSnapType = '';
      el.style.cursor = '';
      el.style.userSelect = '';
    }
    if (e && e.pointerId && el) {
      try { el.releasePointerCapture(e.pointerId); } catch (_) {}
    }
  };

  onPointerUp = (e) => this.endDrag(e);
  onPointerCancel = (e) => this.endDrag(e);

  onClickCapture = (e) => {
    if (this.dragMoved) {
      e.preventDefault();
      e.stopPropagation();
      if (e.nativeEvent && typeof e.nativeEvent.stopImmediatePropagation === 'function') {
        e.nativeEvent.stopImmediatePropagation();
      }
      this.dragMoved = false;
    }
  };

  render() {
    const { children, className, rootclassName, style, ...rest } = this.props;
    // Match original DragScroll behavior: 'h-scroll-wrapper' plus any provided classes
    const classes = ['h-scroll-wrapper'];
    if (rootclassName) classes.push(rootclassName);
    if (className) classes.push(className);

    const mergedStyle = { touchAction: 'pan-x', ...style };

    return (
      <div
        ref={this.slider}
        className={classes.join(' ')}
        style={mergedStyle}
        onPointerDown={this.onPointerDown}
        onPointerMove={this.onPointerMove}
        onPointerUp={this.onPointerUp}
        onPointerCancel={this.onPointerCancel}
        onDragStart={(e) => { e.preventDefault(); }}
        onClickCapture={this.onClickCapture}
        {...rest}
      >
        {children}
      </div>
    );
  }
}

SmoothDragScroll.propTypes = {
  className: PropTypes.string,
  rootclassName: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default SmoothDragScroll;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/DragScroll/SmoothDragScroll.jsx